import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { session: String }

  connect() {
    const currentSession = document.querySelector('meta[name="codex-session-id"]')?.content
    if (currentSession === this.sessionValue) this.element.remove()
  }
}
